/**
 * @generated SignedSource<<27e6a5d8f9836267ff6b23d7a7b06493>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StorecastCreateMutation$variables = {
  assignScreenId?: string | null;
  name: string;
};
export type StorecastCreateMutation$data = {
  readonly createDashboard: {
    readonly dashboard: {
      readonly id: string;
    };
  };
};
export type StorecastCreateMutation = {
  response: StorecastCreateMutation$data;
  variables: StorecastCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "assignScreenId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "assignScreenId",
            "variableName": "assignScreenId"
          },
          {
            "kind": "Variable",
            "name": "name",
            "variableName": "name"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "CreateDashboardOutput",
    "kind": "LinkedField",
    "name": "createDashboard",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Dashboard",
        "kind": "LinkedField",
        "name": "dashboard",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "StorecastCreateMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "StorecastCreateMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "3230cf952486dc4325b6c8c5d28d1fa9",
    "id": null,
    "metadata": {},
    "name": "StorecastCreateMutation",
    "operationKind": "mutation",
    "text": "mutation StorecastCreateMutation(\n  $name: String!\n  $assignScreenId: ID\n) {\n  createDashboard(input: {name: $name, assignScreenId: $assignScreenId}) {\n    dashboard {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bb885a363a3999dd281d09d01663bfb7";

export default node;
